import { Box, Flex, Text } from "rebass/styled-components"
import theme from "../../styles/theme"
import { Icon } from '@iconify/react';
import chevronLeft from '@iconify/icons-entypo/check';

export interface IStepperStep {
  title: string
  description?: string
  isCompleted?: boolean,
  viewed?: boolean
}

interface IStepperProps {
  currentIndex: number,
  steps: Array<IStepperStep>
  onChange: (newIndex: number) => void
}

export const Stepper: React.FC<IStepperProps> = ({ currentIndex, steps, onChange }) => {
  const canAccess = (index: number) => {
    if (index === 0) return true

    if (index > currentIndex) {
      if (!steps[index].isCompleted && !steps[index].viewed) return false
    }
    return true
  }

  return (
    <Flex width={'100%'} mb={4}>
      {steps.map((x, i) => {
        return (
          <>
            <Flex flexDirection={'column'} style={{ cursor: canAccess(i) ? 'pointer' : 'not-allowed' }}
              onClick={() => {
                if (canAccess(i)) {
                  onChange(i)
                }
              }}>
              <Flex>
                <Flex flex={1} alignItems={'center'}>
                  {i > 0 && (
                    <Box style={{ backgroundColor: '#628fcb', height: '2px', width: '100%', opacity: steps[i].isCompleted || steps[i].viewed ? 1 : 0.3 }} />
                  )}
                </Flex>
                <Flex style={{
                  height: '24px', width: '24px', borderRadius: '50%', background:
                    i === currentIndex ? theme.color.primary : '#628fcb', margin: '0 4px',
                  opacity: steps[i].isCompleted || steps[i].viewed ? 1 : 0.4
                }} alignItems={'center'} justifyContent={'center'}
                >
                  {!x.isCompleted ? (
                    <Text style={{ color: 'white' }} fontSize={'11px'} fontWeight={500}>{i + 1}</Text>) : (
                    <Icon
                      icon={chevronLeft}
                      style={{
                        color: 'white',
                        fontSize: '11px',
                      }}
                    />
                  )}
                </Flex>
                <Flex flex={1} alignItems={'center'}>
                  {i < steps.length - 1 && (
                    <Box style={{ backgroundColor: '#628fcb', height: '2px', width: '100%', opacity: steps[i + 1].isCompleted || steps[i + 1].viewed ? 1 : 0.3 }} />
                  )}
                </Flex>
              </Flex>

              <Flex flexDirection={'column'} mt={2} style={{
                opacity: steps[i].isCompleted || steps[i].viewed ? 1 : 0.4
              }}>
                <Text fontSize={'12px'} fontWeight={500} color={i === currentIndex ? '' : '#628fcb'}>{x.title}</Text>
                <Text fontSize={'12px'} fontWeight={300} color={i === currentIndex ? '' : '#628fcb'}>{x.description}</Text>
              </Flex>
            </Flex>

            {i < steps.length - 1 && (
              <Flex flexDirection={'column'} flex={1}>
                <Flex style={{ height: '24px' }} alignItems={'center'}>
                  <Box style={{ backgroundColor: '#628fcb', height: '2px', width: '100%', opacity: steps[i + 1].isCompleted || steps[i + 1].viewed ? 1 : 0.3 }} />
                </Flex>
                <Flex flex={1} />
              </Flex>
            )}
          </>
        )
      })}
    </Flex>
  )
}